import { defineRelations } from "@-/com.npmjs.drizzle-orm";
import * as staticSchema from "#schema";

export const staticRelations = defineRelations(staticSchema, (r) => ({
  grapheme: {
    biau: r.one.graphemeBiau({
      from: r.grapheme.id,
      to: r.graphemeBiau.graphemeId,
    }),
    components: r.many.graphemeComponent({
      from: r.grapheme.id,
      to: r.graphemeComponent.graphemeId,
    }),
    compoundGraphemes: r.many.graphemeCompoundGrapheme({
      from: r.grapheme.id,
      to: r.graphemeCompoundGrapheme.graphemeId,
    }),
    compoundOfGraphemes: r.many.graphemeCompoundGrapheme({
      from: r.grapheme.id,
      to: r.graphemeCompoundGrapheme.compoundGraphemeId,
    }),
    compoundsData: r.one.graphemeCompoundsData({
      from: r.grapheme.id,
      to: r.graphemeCompoundsData.graphemeId,
    }),
    definitions: r.many.graphemeDefinition(),
    hkData: r.one.graphemeHkData({
      from: r.grapheme.id,
      to: r.graphemeHkData.graphemeId,
    }),
    prcData: r.one.graphemePrcData({
      from: r.grapheme.id,
      to: r.graphemePrcData.graphemeId,
    }),
    similarGraphemes: r.many.graphemeSimilarGrapheme({
      from: r.grapheme.id,
      to: r.graphemeSimilarGrapheme.graphemeId,
    }),
    similarToGraphemes: r.many.graphemeSimilarGrapheme({
      from: r.grapheme.id,
      to: r.graphemeSimilarGrapheme.similarGraphemeId,
    }),
    strokeData: r.one.graphemeStrokeData({
      from: r.grapheme.id,
      to: r.graphemeStrokeData.graphemeId,
    }),
    subtlex: r.one.graphemeSubtlex({
      from: r.grapheme.id,
      to: r.graphemeSubtlex.graphemeId,
    }),
    twData: r.one.graphemeTwData({
      from: r.grapheme.id,
      to: r.graphemeTwData.graphemeId,
    }),
    usedAsComponentIn: r.many.graphemeComponent({
      from: r.grapheme.id,
      to: r.graphemeComponent.componentGraphemeId,
    }),
    words: r.many.wordGrapheme({
      from: r.grapheme.id,
      to: r.wordGrapheme.graphemeId,
    }),
  },
  graphemeBiau: {
    grapheme: r.one.grapheme({
      from: r.graphemeBiau.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemeComponent: {
    componentGrapheme: r.one.grapheme({
      from: r.graphemeComponent.componentGraphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
    grapheme: r.one.grapheme({
      from: r.graphemeComponent.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemeCompoundGrapheme: {
    compoundGrapheme: r.one.grapheme({
      from: r.graphemeCompoundGrapheme.compoundGraphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
    grapheme: r.one.grapheme({
      from: r.graphemeCompoundGrapheme.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemeCompoundsData: {
    grapheme: r.one.grapheme({
      from: r.graphemeCompoundsData.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemeDefinition: {
    grapheme: r.one.grapheme({
      from: r.graphemeDefinition.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
    prcData: r.many.graphemeDefinitionPrcData(),
  },
  graphemeDefinitionPrcData: {
    graphemeDefinition: r.one.graphemeDefinition({
      from: r.graphemeDefinitionPrcData.graphemeDefinitionId,
      optional: false,
      to: r.graphemeDefinition.id,
    }),
  },
  graphemeHkData: {
    grapheme: r.one.grapheme({
      from: r.graphemeHkData.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemePrcData: {
    grapheme: r.one.grapheme({
      from: r.graphemePrcData.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemeSimilarGrapheme: {
    grapheme: r.one.grapheme({
      from: r.graphemeSimilarGrapheme.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
    similarGrapheme: r.one.grapheme({
      from: r.graphemeSimilarGrapheme.similarGraphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemeStrokeData: {
    grapheme: r.one.grapheme({
      from: r.graphemeStrokeData.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemeSubtlex: {
    grapheme: r.one.grapheme({
      from: r.graphemeSubtlex.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  graphemeTwData: {
    grapheme: r.one.grapheme({
      from: r.graphemeTwData.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
  },
  sentence: {
    words: r.many.sentenceWord({
      from: r.sentence.id,
      to: r.sentenceWord.sentenceId,
    }),
  },
  sentenceWord: {
    sentence: r.one.sentence({
      from: r.sentenceWord.sentenceId,
      optional: false,
      to: r.sentence.id,
    }),
    word: r.one.word({
      from: r.sentenceWord.wordId,
      optional: false,
      to: r.word.id,
    }),
  },
  word: {
    biau: r.one.wordBiau({
      from: r.word.id,
      to: r.wordBiau.wordId,
    }),
    definitions: r.many.wordDefinition(),
    graphemes: r.many.wordGrapheme({
      from: r.word.id,
      to: r.wordGrapheme.wordId,
    }),
    prcData: r.one.wordPrcData({
      from: r.word.id,
      to: r.wordPrcData.wordId,
    }),
    sentences: r.many.sentenceWord({
      from: r.word.id,
      to: r.sentenceWord.wordId,
    }),
    subtlex: r.one.wordSubtlex({
      from: r.word.id,
      to: r.wordSubtlex.wordId,
    }),
    twData: r.one.wordTwData({
      from: r.word.id,
      to: r.wordTwData.wordId,
    }),
  },
  wordBiau: {
    word: r.one.word({
      from: r.wordBiau.wordId,
      optional: false,
      to: r.word.id,
    }),
  },
  wordDefinition: {
    word: r.one.word({
      from: r.wordDefinition.wordId,
      optional: false,
      to: r.word.id,
    }),
  },
  wordGrapheme: {
    grapheme: r.one.grapheme({
      from: r.wordGrapheme.graphemeId,
      optional: false,
      to: r.grapheme.id,
    }),
    word: r.one.word({
      from: r.wordGrapheme.wordId,
      optional: false,
      to: r.word.id,
    }),
  },
  wordPrcData: {
    word: r.one.word({
      from: r.wordPrcData.wordId,
      optional: false,
      to: r.word.id,
    }),
  },
  wordSubtlex: {
    word: r.one.word({
      from: r.wordSubtlex.wordId,
      optional: false,
      to: r.word.id,
    }),
  },
  wordTwData: {
    word: r.one.word({
      from: r.wordTwData.wordId,
      optional: false,
      to: r.word.id,
    }),
  },
}));
